/**
 * Hopin shared session user
 * Hopin session is never checked with custom domain canvas
 */

import {
  createAsyncThunk,
  createSelector,
  createSlice,
} from "@reduxjs/toolkit";
import type { ErrorResponse, User } from "src/types";

import { getState } from "@/features/helpers";
import endpoints from "@/utils/endpoints";
import { authenticatedFetch } from "@/utils/fetchJSON";
import { isError } from "@/utils/is-error";

const get = endpoints();

const initialState: User | null = null;

export const fetchUser = createAsyncThunk<User | ErrorResponse>(
  "user/fetchUser",
  () =>
    authenticatedFetch.fetchJSON(get("HOPIN_USER"), {
      credentials: "include",
    })
);

const userSlice = createSlice({
  name: "user",
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder.addCase(fetchUser.fulfilled, (_state, action) => {
      return isError(action.payload) ? null : action.payload;
    });
  },
});

const getUser = createSelector(getState, (state) => state.user);

export { getUser };
export default userSlice.reducer;
